import { render } from "./detail.html?vue&type=template&id=6c00568a&scoped=true&ts=true"
import script from "./detail.ts?vue&type=script&lang=ts"
export * from "./detail.ts?vue&type=script&lang=ts"

import "./detail.scss?vue&type=style&index=0&id=6c00568a&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Vigiflow\\automation-logs-adminlte-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c00568a"]])

export default __exports__